import React from 'react';
import '../App.css';
import './contact.css';
import { Helmet } from "react-helmet";
import ContactForm from './ContactForm.js'
//import { GiPineTree } from "react-icons/gi";
import { GiPalmTree } from "react-icons/gi";
import { HiOutlineMailOpen } from "react-icons/hi";
import { PiPhoneCallBold } from "react-icons/pi";
import { useScrollBehavior } from './useScrollBehavior.js';
//import { GiWillowTree } from "react-icons/gi";
import Footer from './footer4.js'


const Contact = () => {

	useScrollBehavior();

	return (
		<>
		<Helmet>
  			<title>Contact Us | Sam's Tree Service</title>
  			<meta name="description" content="Get in touch with Sam's Tree Service for expert tree care in Sarasota, FL. Request a free estimate or ask us about our services today." />
			<link rel="canonical" href="https://samstreeservice.com/contact" />
		</Helmet>

		<div id='main_contactDiv'>
			<div className="background-imagecontact"></div>
            <div className="module_contact" id="module_contact1">
				<div id='contact_div1'>
					<div id='cover_contact_div1'>
						<div id='contact_title'>
							<h1>Contact US</h1>
						</div>
					</div>
				</div>	
            </div>
			<div className="module_contact" id="module_contact2">
				<div id='contact_div3'>
					<div id='contactform_div'>
          				<div id='contact_div3_text_10_container'>
							<div id='contact_div3_text_10'>
							  <div id='icon_contact_div3_text_10'>
								  <div id='contact_div3_text_10_text2_1'><h1> - - - - - -&nbsp;&nbsp;</h1>
								  </div><div id='contact_div3_text_10_half_icon2'><GiPalmTree /></div>
								  <div id='contact_div3_text_10_text2_2'><h1>&nbsp;- - - - - -</h1></div>
							  </div>
							  <div id='icon_contact_div3_text_10_subtext'>
								 <h1>Get a Free Estimate!</h1>
								  <p>With countless 5-star reviews and a proven reputation, 
								  <strong>Sam's Tree Service</strong> is your trusted partner for all your tree care needs. 
								  Contact us now for a free consultation and personalized estimate!</p>
							  </div>
								<div id='contact_div3_subdiv1' className='contact_div3_subdiv' onClick={() => window.location.href = 'mailto:email@email.com'}
									  style={{ cursor: 'pointer' }}>
									<div className='circle_icon_contact_div3'><HiOutlineMailOpen /></div>
									<div className='contact_div3_subdiv_text'>
									  <h1>Email</h1>
									  <p>contact@samstreeservice.com</p>
									</div>
								</div>
								<div className='contact_div3_subdiv' onClick={() => window.location.href = 'tel:941-879-8853'}
									  style={{ cursor: 'pointer' }}>
									<div className='circle_icon_contact_div3'><PiPhoneCallBold /></div>
									<div className='contact_div3_subdiv_text'>
									  <h1>Phone</h1>
									  <p>941-879-8853</p>
									</div>
								</div>
							  </div>
						</div>
						<ContactForm/>
        			</div>
					
				</div>
			</div>
			<Footer/>
		</div>
	</>	
	);
};

export default Contact;
